export default {
    data: () => ({
        translations: {
            createSupplier: {
                el: "Προσθήκη Προμηθευτή",
                en: "Create Supplier",
                it: "Aggiungere un fornitore"
            },
            supplier: {
                el: "Προμηθευτής",
                en: "Supplier",
                it: "Fornitore"
            },
            male: {
                el: "Αρσενικό",
                en: "Male",
                it: "Maschio" 
            },
            female: {
                el: "Θηλυκό",
                en: "Female",
                it: "Femminile" 
            },
            other: {
                el: "Άλλο",
                en: "Other",
                it: "Altro" 
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            supplierManager: {
                el: "Διαχειριστής Προμηθευτή",
                en: "Supplier Manager",
                it: "Responsabile del Fornitore"
            },
            mobile: {
                el: "Τηλέφωνο",
                en: "Mobile",
                it: "Telefono"
            },
            primary_email: {
                el: "Πρωτεύον Email",
                en: "Primary Email",
                it: "E-mail primario"
            },
            secondary_email: {
                el: "Δευτερεύον Email",
                en: "Secondary Email",
                it: "Email secondaria"
            },
            earned_gift_message: {
                el: "",
                en: "Earned Gift Message",
                it: ""
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            save: {
                el: "Αποθήκευση",
                en: "Save",
                it: "Salva"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            supplier_name: {
                el: "Name",
                en: "Name",
                it: "Nome"
            },
            user_full_name: {
                el: "Ονοματεπώνυμο",
                en: "Full Name",
                it: "Nome e cognome"
            },
            supplier_primary_phone: {
                el: "Τηλέφωνο",
                en: "Primary Phone",
                it: "Telefono"
            },
            user_mobile: {
                el: "Τηλέφωνο",
                en: "Mobile",
                it: "Telefono"
            },
            content: {
                el: "Περιεχόμενο",
                en: "Content",
                it: "Contenuto"
            },
            info: {
                el: "Μπορείτε επίσης να χρησιμοποιήσετε δυναμικό περιεχόμενο για το μήνυμά σας, όπως το όνομα του δώρου ή τα σημεία που χρησιμοποίησε ο χρήστης. Για να το κάνετε αυτό, δείτε τις παρακάτω πληροφορίες:",
                en: "You can also use dynamic content for your message, like the name of the gift or the points the user used. In order to do that see the information bellow:",
                it: "Puoi anche utilizzare contenuti dinamici per il tuo messaggio, come il nome del regalo o i punti utilizzati dall'utente. Per fare ciò, vedere le informazioni di seguito:"
            },
            pointsInfo: {
                el: "Για τους πόντους του δώρου χρησιμοποιήστε:",
                en: "For the points of the gift use:",
                it: "Per i punti del regalo usa:"
            },
            nameInfo: {
                el: "Για το όνομα του δώρου χρησιμοποιήστε:",
                en: "For the name of the gift use:",
                it: "Per il nome del regalo usa:"
            },
            subject: {
                el: "Θέμα",
                en: "Subject",
                it: "Soggetto"
            },
            supplier_email_1: {
                el: "Πρωτεύον Email",
                en: "Primary Email",
                it: "E-mail primario"
            },
            supplier_email_2: {
                el: "Δευτερεύον Email",
                en: "Secondary Email",
                it: "Email secondaria"
            },
            user_email_1: {
                el: "Πρωτεύον Email",
                en: "Primary Email",
                it: "E-mail primario"
            },
            user_email_2: {
                el: "Δευτερεύον Email",
                en: "Secondary Email",
                it: "Email secondaria"
            },
            supplier_country: {
                el: "Χώρα",
                en: "Country",
                it: "Paese"
            },
            user_country: {
                el: "Χώρα",
                en: "Country",
                it: "Paese"
            },
            user_gender: {
                el: "Φύλο",
                en: "Gender",
                it: "Sesso"
            }
        }
    })
};
